const countryCode = [
  {
    value: 'AL',
    label: 'ALBANIA 阿尔巴尼亚'
  },
  {
    value: 'DZ',
    label: 'ALGERIA 阿尔及利亚'
  },
  {
    value: 'AS',
    label: 'AMERICAN SAMOA 美属萨摩亚'
  },
  {
    value: 'AD',
    label: 'ANDORRA 安道尔'
  },
  {
    value: 'AO',
    label: 'ANGOLA 安哥拉'
  },
  {
    value: 'AI',
    label: 'ANGUILLA 安圭拉'
  },
  {
    value: 'AG',
    label: 'ANTIGUA AND BARBUDA 安提瓜和巴布达'
  },
  {
    value: 'AR',
    label: 'ARGENTINA 阿根廷'
  },
  {
    value: 'AM',
    label: 'ARMENIA 亚美尼亚'
  },
  {
    value: 'AW',
    label: 'ARUBA 阿鲁巴'
  },
  {
    value: 'AU',
    label: 'AUSTRALIA 澳大利亚'
  },
  {
    value: 'AT',
    label: 'AUSTRIA 奥地利'
  },
  {
    value: 'AZ',
    label: 'AZERBAIJAN 阿塞拜疆'
  },
  {
    value: 'BS',
    label: 'BAHAMAS 巴哈马群岛'
  },
  {
    value: 'BH',
    label: 'BAHRAIN 巴林'
  },
  {
    value: 'BD',
    label: 'BANGLADESH 孟加拉国'
  },
  {
    value: 'BB',
    label: 'BARBADOS 巴巴多斯'
  },
  {
    value: 'BY',
    label: 'BELARUS 白俄罗斯'
  },
  {
    value: 'BE',
    label: 'BELGIUM 比利时'
  },
  {
    value: 'BZ',
    label: 'BELIZE 伯利兹'
  },
  {
    value: 'BJ',
    label: 'BENIN 贝宁'
  },
  {
    value: 'BM',
    label: 'BERMUDA 百慕大群岛'
  },
  {
    value: 'BT',
    label: 'BHUTAN 不丹'
  },
  {
    value: 'BO',
    label: 'BOLIVIA, PLURINATIONAL STATE OF 玻利维亚多民族国'
  },
  {
    value: 'BQ',
    label: 'BONAIRE, SINT EUSTATIUS AND SABA 博内尔、圣尤斯特歇斯和萨巴'
  },
  {
    value: 'BA',
    label: 'BOSNIA AND HERZEGOVINA 波斯尼亚和黑塞哥维那'
  },
  {
    value: 'BW',
    label: 'BOTSWANA 博茨瓦纳'
  },
  {
    value: 'BR',
    label: 'BRAZIL 巴西'
  },
  {
    value: 'BN',
    label: 'BRUNEI DARUSSALAM 文莱达鲁萨兰国'
  },
  {
    value: 'BG',
    label: 'BULGARIA 保加利亚'
  },
  {
    value: 'BF',
    label: 'BURKINA FASO 布基纳法索'
  },
  {
    value: 'BI',
    label: 'BURUNDI 布隆迪'
  },
  {
    value: 'CV',
    label: 'CAPE VERDE 佛得角'
  },
  {
    value: 'KH',
    label: 'CAMBODIA 柬埔寨'
  },
  {
    value: 'CM',
    label: 'CAMEROON 喀麦隆'
  },
  {
    value: 'KY',
    label: 'CAYMAN ISLANDS 开曼群岛'
  },
  {
    value: 'CF',
    label: 'CENTRAL AFRICAN REPUBLIC 中非共和国'
  },
  {
    value: 'TD',
    label: 'CHAD 乍得'
  },
  {
    value: 'CL',
    label: 'CHILE 智利'
  },
  {
    value: 'CO',
    label: 'COLOMBIA 哥伦比亚'
  },
  {
    value: 'KM',
    label: 'COMOROS 科摩罗'
  },
  {
    value: 'CG',
    label: 'DRC 刚果'
  },
  {
    value: 'CD',
    label: 'CONGO 刚果民主共和国'
  },
  {
    value: 'CK',
    label: 'COOK ISLANDS 库克群岛'
  },
  {
    value: 'CR',
    label: 'COSTA RICA 哥斯达黎加'
  },
  {
    value: 'CI',
    label: "COTE D'IVOIRE 科特迪瓦"
  },
  {
    value: 'HR',
    label: 'CROATIA 克罗地亚'
  },
  {
    value: 'CU',
    label: 'CUBA 古巴'
  },
  {
    value: 'CW',
    label: 'CURACAO 库拉索'
  },
  {
    value: 'CY',
    label: 'CYPRUS 塞浦路斯'
  },
  {
    value: 'CZ',
    label: 'Czech Republic 捷克'
  },
  {
    value: 'DK',
    label: 'DENMARK 丹麦'
  },
  {
    value: 'DJ',
    label: 'DJIBOUTI 吉布提'
  },
  {
    value: 'DM',
    label: 'DOMINICA 多米尼加'
  },
  {
    value: 'EC',
    label: 'ECUADOR 厄瓜多尔'
  },
  {
    value: 'EG',
    label: 'EGYPT 埃及'
  },
  {
    value: 'SV',
    label: 'EL SALVADOR 萨尔瓦多'
  },
  {
    value: 'GQ',
    label: 'EQUATORIAL GUINEA 赤道几内亚'
  },
  {
    value: 'ER',
    label: 'ERITREA 厄立特里亚'
  },
  {
    value: 'EE',
    label: 'ESTONIA 爱沙尼亚'
  },
  {
    value: 'SZ',
    label: 'ESWATINI 埃斯瓦蒂尼'
  },
  {
    value: 'ET',
    label: 'ETHIOPIA 埃塞俄比亚'
  },
  {
    value: 'FK',
    label: 'FALKLAND ISLANDS (MALVINAS) 福克兰群岛（马尔维纳斯）'
  },
  {
    value: 'FO',
    label: 'FAROE ISLANDS 法罗群岛'
  },
  {
    value: 'FJ',
    label: 'FIJI 斐济'
  },
  {
    value: 'FI',
    label: 'FINLAND 芬兰'
  },
  {
    value: 'FR',
    label: 'FRANCE 法国'
  },
  {
    value: 'GF',
    label: 'FRENCH GUIANA 法属圭亚那'
  },
  {
    value: 'PF',
    label: 'FRENCH POLYNESIA 法属波利尼西亚'
  },
  {
    value: 'GA',
    label: 'GABON 加蓬'
  },
  {
    value: 'GM',
    label: 'GAMBIA 冈比亚'
  },
  {
    value: 'GE',
    label: 'GEORGIA 格鲁吉亚'
  },
  {
    value: 'DE',
    label: 'GERMANY 德国'
  },
  {
    value: 'GH',
    label: 'GHANA 迦纳'
  },
  {
    value: 'GI',
    label: 'GIBRALTAR 直布罗陀'
  },
  {
    value: 'GR',
    label: 'GREECE 希腊'
  },
  {
    value: 'GL',
    label: 'GREENLAND 格陵兰'
  },
  {
    value: 'GD',
    label: 'GRENADA 格林纳达'
  },
  {
    value: 'GP',
    label: 'GUADELOUPE 瓜德罗普'
  },
  {
    value: 'GU',
    label: 'GUAM 关岛'
  },
  {
    value: 'GT',
    label: 'GUATEMALA 瓜地马拉'
  },
  {
    value: 'GG',
    label: 'GUERNSEY 根西岛'
  },
  {
    value: 'GN',
    label: 'GUINEA 几内亚'
  },
  {
    value: 'GW',
    label: 'GUINEA BISSAU 几内亚比绍'
  },
  {
    value: 'GY',
    label: 'GUYANA 圭亚那'
  },
  {
    value: 'HT',
    label: 'HAITI 海地'
  },
  {
    value: 'HN',
    label: 'HONDURAS 洪都拉斯'
  },
  {
    value: 'HK',
    label: 'HONG KONG 中国香港'
  },
  {
    value: 'HU',
    label: 'HUNGARY 匈牙利'
  },
  {
    value: 'IS',
    label: 'ICELAND 冰岛'
  },
  {
    value: 'IN',
    label: 'INDIA 印度'
  },
  {
    value: 'ID',
    label: 'INDONESIA 印度尼西亚'
  },
  {
    value: 'IR',
    label: 'IRAN 伊朗伊斯兰共和国'
  },
  {
    value: 'IQ',
    label: 'IRAQ 伊拉克'
  },
  {
    value: 'IE',
    label: 'IRELAND 爱尔兰'
  },
  {
    value: 'IM',
    label: 'ISLE OF MAN 马恩岛'
  },
  {
    value: 'IL',
    label: 'ISRAEL 以色列'
  },
  {
    value: 'IT',
    label: 'ITALY 意大利'
  },
  {
    value: 'JM',
    label: 'JAMAICA 牙买加'
  },
  {
    value: 'JP',
    label: 'JAPAN 日本'
  },
  {
    value: 'JE',
    label: 'JERSEY 泽西'
  },
  {
    value: 'JO',
    label: 'JORDAN 约旦'
  },
  {
    value: 'KZ',
    label: 'KAZAKHSTAN 哈萨克斯坦'
  },
  {
    value: 'KE',
    label: 'KENYA 肯尼亚'
  },
  {
    value: 'KI',
    label: 'KIRIBATI 基里巴斯'
  },
  {
    value: 'KP',
    label: "KOREA (DEMOCRATIC PEOPLE'S REPUBLIC OF) 朝鲜"
  },
  {
    value: 'KR',
    label: 'KOREA, REPUBLIC OF 韩国'
  },
  {
    value: 'XK',
    label: 'KOSOVO, REPUBLIC OF 科索沃共和国'
  },
  {
    value: 'KW',
    label: 'KUWAIT 科威特'
  },
  {
    value: 'KG',
    label: 'KYRGYZSTAN 吉尔吉斯斯坦'
  },
  {
    value: 'LA',
    label: "LAO PEOPLE'S DEMOCRATIC REPUBLIC 老挝人民民主共和国"
  },
  {
    value: 'LV',
    label: 'LATVIA 拉脱维亚'
  },
  {
    value: 'LB',
    label: 'LEBANON 黎巴嫩'
  },
  {
    value: 'LS',
    label: 'LESOTHO 莱索托'
  },
  {
    value: 'LR',
    label: 'LIBERIA 利比里亚'
  },
  {
    value: 'LY',
    label: 'LIBYA 利比亚'
  },
  {
    value: 'LI',
    label: 'LIECHTENSTEIN 列支敦士登'
  },
  {
    value: 'LT',
    label: 'LITHUANIA 立陶宛'
  },
  {
    value: 'LU',
    label: 'LUXEMBOURG 卢森堡'
  },
  {
    value: 'MO',
    label: 'MACAO 中国澳门'
  },
  {
    value: 'MG',
    label: 'MADAGASCAR 马达加斯加'
  },
  {
    value: 'MW',
    label: 'MALAWI 马拉维'
  },
  {
    value: 'MY',
    label: 'MALAYSIA 马来西亚'
  },
  {
    value: 'MV',
    label: 'MALDIVES 马尔代夫'
  },
  {
    value: 'ML',
    label: 'MALI 马里'
  },
  {
    value: 'MT',
    label: 'MALTA 马耳他'
  },
  {
    value: 'MH',
    label: 'MARSHALL ISLANDS 马绍尔群岛'
  },
  {
    value: 'MQ',
    label: 'MARTINIQUE 马提尼克'
  },
  {
    value: 'MR',
    label: 'MAURITANIA 毛里塔尼亚'
  },
  {
    value: 'MU',
    label: 'MAURITIUS 毛里求斯'
  },
  {
    value: 'YT',
    label: 'MAYOTTE 马约特'
  },
  {
    value: 'MX',
    label: 'MEXICO 墨西哥'
  },
  {
    value: 'FM',
    label: 'MICRONESIA (FEDERATED STATES OF) 密克罗尼西亚联邦'
  },
  {
    value: 'MD',
    label: 'MOLDOVA 摩尔多瓦共和国'
  },
  {
    value: 'MC',
    label: 'MONACO 摩纳哥'
  },
  {
    value: 'MN',
    label: 'MONGOLIA 蒙古'
  },
  {
    value: 'ME',
    label: 'MONTENEGRO 黑山'
  },
  {
    value: 'MS',
    label: 'MONTSERRAT 蒙特塞拉特'
  },
  {
    value: 'MA',
    label: 'MOROCCO 摩洛哥'
  },
  {
    value: 'MZ',
    label: 'MOZAMBIQUE 莫桑比克'
  },
  {
    value: 'MM',
    label: 'MYANMAR 缅甸'
  },
  {
    value: 'NA',
    label: 'NAMIBIA 纳米比亚'
  },
  {
    value: 'NR',
    label: 'NAURU 瑙鲁'
  },
  {
    value: 'NP',
    label: 'NEPAL 尼泊尔'
  },
  {
    value: 'NL',
    label: 'NETHERLANDS 荷兰'
  },
  {
    value: 'NC',
    label: 'NEW CALEDONIA 新喀里多尼亚'
  },
  {
    value: 'NZ',
    label: 'NEW ZEALAND 新西兰'
  },
  {
    value: 'NI',
    label: 'NICARAGUA 尼加拉瓜'
  },
  {
    value: 'NE',
    label: 'NIGER 尼日尔'
  },
  {
    value: 'NG',
    label: 'NIGERIA 尼日利亚'
  },
  {
    value: 'MK',
    label: 'NORTH MACEDONIA 北马其顿'
  },
  {
    value: 'MP',
    label: 'NORTHERN MARIANA ISLANDS 北马里亚纳群岛'
  },
  {
    value: 'NO',
    label: 'NORWAY 挪威'
  },
  {
    value: 'OM',
    label: 'OMAN 阿曼'
  },
  {
    value: 'PK',
    label: 'PAKISTAN 巴基斯坦'
  },
  {
    value: 'PW',
    label: 'PALAU 帕劳'
  },
  {
    value: 'PS',
    label: 'PALESTINE, STATE OF 巴勒斯坦国'
  },
  {
    value: 'PA',
    label: 'PANAMA 巴拿马'
  },
  {
    value: 'PG',
    label: 'PAPUA NEW GUINEA 巴布亚新几内亚'
  },
  {
    value: 'PY',
    label: 'PARAGUAY 巴拉圭'
  },
  {
    value: 'PE',
    label: 'PERU 秘鲁'
  },
  {
    value: 'PH',
    label: 'PHILIPPINES 菲律宾'
  },
  {
    value: 'PL',
    label: 'POLAND 波兰'
  },
  {
    value: 'PT',
    label: 'PORTUGAL 葡萄牙'
  },
  {
    value: 'PR',
    label: 'PUERTO RICO 波多黎各'
  },
  {
    value: 'QA',
    label: 'QATAR 卡塔尔'
  },
  {
    value: 'RE',
    label: 'REUNION 留尼旺岛'
  },
  {
    value: 'RO',
    label: 'ROMANIA 罗马尼亚'
  },
  {
    value: 'RU',
    label: 'RUSSIAN FEDERATION 俄罗斯联邦'
  },
  {
    value: 'RW',
    label: 'RWANDA 卢旺达'
  },
  {
    value: 'KN',
    label: 'SAINT KITTS AND NEVIS 圣基茨和尼维斯'
  },
  {
    value: 'LC',
    label: 'SAINT LUCIA 圣露西亚'
  },
  {
    value: 'PM',
    label: 'SAINT PIERRE AND MIQUELON 圣皮埃尔和密克隆'
  },
  {
    value: 'VC',
    label: 'SAINT VINCENT AND THE GRENADINES 圣文森特和格林纳丁斯'
  },
  {
    value: 'WS',
    label: 'SAMOA 萨摩亚'
  },
  {
    value: 'SM',
    label: 'SAN MARINO 圣马利诺'
  },
  {
    value: 'ST',
    label: 'SAO TOME AND PRINCIPE 圣多美和普林西比'
  },
  {
    value: 'SA',
    label: 'SAUDI ARABIA 沙特阿拉伯'
  },
  {
    value: 'SN',
    label: 'SENEGAL 塞内加尔'
  },
  {
    value: 'RS',
    label: 'SERBIA 塞尔维亚'
  },
  {
    value: 'SC',
    label: 'SEYCHELLES 塞舌尔'
  },
  {
    value: 'SL',
    label: 'SIERRA LEONE 塞拉利昂'
  },
  {
    value: 'SG',
    label: 'SINGAPORE 新加坡'
  },
  {
    value: 'SK',
    label: 'SLOVAKIA 斯洛伐克'
  },
  {
    value: 'SI',
    label: 'SLOVENIA 斯洛文尼亚'
  },
  {
    value: 'SB',
    label: 'SOLOMON ISLANDS 所罗门群岛'
  },
  {
    value: 'SO',
    label: 'SOMALIA 索马利亚'
  },
  {
    value: 'ZA',
    label: 'SOUTH AFRICA 南非'
  },
  {
    value: 'SS',
    label: 'SOUTH SUDAN 南苏丹'
  },
  {
    value: 'ES',
    label: 'SPAIN 西班牙'
  },
  {
    value: 'LK',
    label: 'SRI LANKA 斯里兰卡'
  },
  {
    value: 'SD',
    label: 'SUDAN 苏丹'
  },
  {
    value: 'SR',
    label: 'SURINAME 苏里南'
  },
  {
    value: 'SE',
    label: 'SWEDEN 瑞典'
  },
  {
    value: 'CH',
    label: 'SWITZERLAND 瑞士'
  },
  {
    value: 'SY',
    label: 'SYRIAN ARAB REPUBLIC 阿拉伯叙利亚共和国'
  },
  {
    value: 'TW',
    label: 'TAIWAN 中国台湾'
  },
  {
    value: 'TJ',
    label: 'TAJIKISTAN 塔吉克斯坦'
  },
  {
    value: 'TZ',
    label: 'TANZANIA 坦桑尼亚联合共和国'
  },
  {
    value: 'TH',
    label: 'THAILAND 泰国'
  },
  {
    value: 'TL',
    label: 'TIMOR-LESTE 蒂莫尔-莱斯特'
  },
  {
    value: 'TG',
    label: 'TOGO 多哥'
  },
  {
    value: 'TO',
    label: 'TONGA 汤加'
  },
  {
    value: 'TT',
    label: 'TRINIDAD AND TOBAGO 特立尼达和多巴哥'
  },
  {
    value: 'TN',
    label: 'TUNISIA 突尼斯'
  },
  {
    value: 'TR',
    label: 'TURlabel 土耳其'
  },
  {
    value: 'TM',
    label: 'TURKMENISTAN 土库曼斯坦'
  },
  {
    value: 'TC',
    label: 'TURKS AND CAICOS ISLANDS 特克斯和凯科斯群岛'
  },
  {
    value: 'TV',
    label: 'TUVALU 图瓦卢'
  },
  {
    value: 'UG',
    label: 'UGANDA 乌干达'
  },
  {
    value: 'UA',
    label: 'UKRAINE 乌克兰'
  },
  {
    value: 'AE',
    label: 'UNITED ARAB EMIRATES 阿拉伯联合酋长国'
  },
  {
    value: 'GB',
    label: 'UNITED KINGDOM 英国'
  },
  {
    value: 'US',
    label: 'UNITED STATES 美国'
  },
  {
    value: 'UY',
    label: 'URUGUAY 乌拉圭'
  },
  {
    value: 'UZ',
    label: 'UZBEKISTAN 乌兹别克斯坦'
  },
  {
    value: 'VU',
    label: 'VANUATU 瓦努阿图'
  },
  {
    value: 'VE',
    label: 'VENEZUELA (BOLIVARIAN REPUBLIC OF) 委内瑞拉玻利瓦尔共和国'
  },
  {
    value: 'VN',
    label: 'VIETNAM 越南'
  },
  {
    value: 'VI',
    label: 'VIRGIN ISLANDS (U.S.) 维尔京群岛（美国）'
  },
  {
    value: 'VG',
    label: 'VIRGIN ISLANDS, BRITISH 英属维尔京群岛'
  },
  {
    value: 'WF',
    label: 'WALLIS AND FUTUNA 瓦利斯和富图纳'
  },
  {
    value: 'YE',
    label: 'YEMEN 也门'
  },
  {
    value: 'ZM',
    label: 'ZAMBIA 赞比亚'
  },
  {
    value: 'ZW',
    label: 'ZIMBABWE 津巴布韦'
  },
  {
    value: 'CN',
    label: 'CHINA 中国'
  }
]
export default countryCode
